import React from "react";

import Inputs from "./components/Inputs";
import Map from "./components/Map";

import classes from "./index.module.css";

const Contact = () => {
  return (
    <div id="contact" className={classes["wrapper"]}>
      <Inputs />
      <Map />
    </div>
  );
};

export default Contact;
